<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    App list
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="isError"> {{ errorMessage }} </alert-fail>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="currentPage"
                          :per-page="numberPerPage"
                          class="table-app"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-app"
                          selectable
                          selectedVariant="single"
                          :fields="fields"
                          :items="list">
                          <template slot="name" slot-scope="row">
                            {{ row.item.name }}
                          </template>
                            <template slot="createdDate" slot-scope="row">
                            {{ row.item.createdDate }}
                          </template>
                          <template slot="ios" slot-scope="row">
                            <b-button variant="outline-dark" @click="viewIOSDetail(row.item.id)">Details</b-button>
                          </template>
                          <template slot="android" slot-scope="row">
                            <b-button variant="outline-dark" @click="viewAndroidDetail(row.item.id)">Details</b-button>
                          </template>
                          <template slot="app" slot-scope="row">
                            <b-button variant="outline-dark" @click="editApp(row.item)">Edit</b-button>
                            <b-button variant="danger" style="margin-left: 10px;" @click="deleteApp(row.item.id)">Delete</b-button>
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                    <b-col>
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="numberPerPage"
                        class="my-0"
                        ></b-pagination>
                    </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import MessageAppInfo from '@/models/messageappinfo.js';
import AlertFail from '../../components/alert/AlertFail';
import { reformatDate } from '../../assets/utils/formatter';
export default {
  data () {
    return {
      AppList: [new MessageAppInfo({ id: '1', name: 'App 1', ios: '', android: '', createdat: '1568275903' })],
      isBusy: false,
      numberPerPage: 10,
      fields: [
        { key: 'name' },
        { key: 'ios' },
        { key: 'android' },
        { key: 'createdDate' },
        { key: 'app' }
      ],
      list: [],
      isError: false,
      errorMessage: '',
      currentPage: 1,
      totalRows: 1
    };
  },
  methods: {
    async getAppList () {
      try {
        const appsResponse = await this.axios.get(process.env.VUE_APP_URL_MESSAGING_API + '/app');
        const appList = appsResponse.data.data.apps;
        for (const app of appList) {
          this.list.push({
            id: app.id,
            createdDate: reformatDate(app.createdAt),
            name: app.name,
            remark: app.remark
          });
        }
      } catch (e) {
        console.log(e);
        this.errorHandler(e);
      }

      this.totalRows = this.list.length;
      this.isBusy = false;
      return this.list;
    },
    deleteApp (appId) {
      if (confirm('Are you sure to delete this app?')) {
        if (appId) {
          this.axios({
            method: 'delete',
            url: (process.env.VUE_APP_URL_MESSAGING_API + '/app/' + appId)
          }).then(res => {
            const receivedResp = res.data;
            if ('Success' === receivedResp.message) {
              alert('Application has been successfully deleted.');
              this.list = [];
              this.getAppList();
            }
          })
            .catch(error => console.log(error));
        }
      }
    },
    viewIOSDetail (appId) {
      this.$router.push({ name: 'messaging-app-ios-provider', params: { id: appId } });
    },
    viewAndroidDetail (appId) {
      this.$router.push({ name: 'messaging-app-android-provider', params: { id: appId } });
    },
    editApp (app) {
      sessionStorage.setItem('msgapp', JSON.stringify(app));
      this.$router.push({ name: 'messaging-edit-app', params: { id: app.id } });
    },
    errorHandler (error) {
      console.log(error);
      this.errorMessage = error.message;
      if (error.message) {
        this.errorMessage = error.message;
        this.isError = true;
      }
    }
  },
  components: {
    AlertFail
  },
  created () {
    this.getAppList();
    document.title = 'Admin Console: Messaging Apps List';
  }
};
</script>
